import { type PropsWithChildren } from 'react';

import type { SupportedLocale } from '@/utils/i18n/supportedLocales';
import { OsLocaleContext, RtlLocaleFlagContext } from './os-locale-context.utils';

/**
 * Mounted by `HeidiIntlProvider` (which wraps every page in `_app.tsx`) to
 * hoist the OS/browser locale above the ~1,100 `useTranslations()` consumers.
 * See `./os-locale-context.utils` (SCR-5924) for why this exists.
 */
export const OsLocaleContextProvider = ({
  value,
  isRtlLocaleFeatureEnabled,
  children,
}: PropsWithChildren<{
  value: SupportedLocale | undefined;
  /** The RTL flag, read once by the mounting provider (`useScribeEnableRtlFlagSource`). */
  isRtlLocaleFeatureEnabled: boolean;
}>) => (
  <OsLocaleContext.Provider value={value}>
    <RtlLocaleFlagContext.Provider value={isRtlLocaleFeatureEnabled}>
      {children}
    </RtlLocaleFlagContext.Provider>
  </OsLocaleContext.Provider>
);
